//componente de imagen segura
// src = url. alt = texto. style = css. fallbacksrc = imagen de notdesign.
// showloader = mostrar el circulo de carga. onclick = callback
import React from 'react';
import { CircularProgress } from '@mui/material';
import useImagenSegura from '../hooks/useImagenSegura';
import NotDesign from '../assets/design-not-available.png';

const ImagenSegura = ({ src, alt = 'Imagen', style = {}, fallbackSrc = NotDesign,
  showLoader = true, onClick, ...props }) => {

  const { imageUrl, loading, error } = useImagenSegura(
    src, { lazy: false, }
  );

  if (loading && showLoader) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...style
        }}
      >
        <CircularProgress size={40} sx={{ color: '#5656FF' }} />
      </div>
    );
  }

  if (error) {
    return (
      <img
        src={fallbackSrc}
        alt={alt}
        style={style}
        onClick={onClick}
        {...props}
      />
    );
  }

  if (!imageUrl) {
    return null;
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      style={style}
      onClick={onClick}
      {...props}
    />
  );
};

export default ImagenSegura;